import { validateAll } from './functions/all';
import { validateAny } from './functions/any';
import { validateArray } from './functions/array';
import { validateIsEqualTo } from './functions/is-equal-to';
import { validateNonEmptyString } from './functions/non-empty-string';
import { validateNumber } from './functions/number';
import { validateObject } from './functions/object';
import { validateObjectOf } from './functions/object-of';
import { validateOneOf } from './functions/one-of';
import { validateOptional } from './functions/optional';
import { validateString } from './functions/string';
import { validateBoolean, validateFn, validateOfType, validateSymbol } from './functions/type';
export const Validator = {
    all: validateAll,
    any: validateAny,
    array: validateArray,
    isEqualTo: validateIsEqualTo,
    number: validateNumber,
    object: validateObject,
    objectOf: validateObjectOf,
    oneOf: validateOneOf,
    optional: validateOptional,
    string: validateString,
    nonEmptyString: validateNonEmptyString,
    boolean: validateBoolean,
    fn: validateFn,
    ofType: validateOfType,
    symbol: validateSymbol
};
//# sourceMappingURL=validator.js.map